function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M20.25,6A2.25,2.25,0,1,0,22.5,8.25,2.25,2.25,0,0,0,20.25,6m-.54,7.155c-1.785.15-6.66,4.035-6.66,4.035-.3.225-.21.21.03.63s.21.435.495.24c.3-.195.8-.51,1.62-1.02,3.18-2.04.51,2.67-.855,10.6-.54,3.93,3,1.905,3.915,1.305.9-.585,3.315-2.25,3.555-2.415.33-.225.09-.405-.165-.78-.18-.255-.36-.075-.36-.075-.975.645-2.76,2-3,1.14-.285-.855,1.545-6.72,2.55-10.755.165-.96.615-3.06-1.125-2.91Z",
  transform: "translate(-12.86 -6)",
  fill: "#d6d6d6"
});

var SvgAboutVariant = function SvgAboutVariant(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9.64,
    height: 24.007,
    viewBox: "0 0 9.64 24.007",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAboutVariant, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/about-variant.31541780.svg";
export { ForwardRef as ReactComponent };